define('CCTSlider.View',
  [
    'uc_cct_slider.tpl',
    'CustomContentType.Base.View',
    'jQuery'
  ],
  function (
    uc_cct_slider_tpl,
    CustomContentTypeBaseView,
    jQuery
  ) {
    'use strict';

    return CustomContentTypeBaseView.extend({

      template: uc_cct_slider_tpl,

      initialize: function initialize(options) {
        var self = this;

        if (options) {
          this.container = options.container;
        }

        this._initialize();

        this.on('afterViewRender', function () {
          jQuery('#uc-slider').ready(function () {
            var hasMoreThanOneSlider = jQuery('.uc-slider-main').children().length > 1;
            if (hasMoreThanOneSlider) {
              if (!jQuery('.bx-wrapper').length) {
                self.sliderContainer = jQuery('.uc-slider-main').bxSlider({
                  auto: self.sliderAutoPlay(),
                  pause: self.sliderSpeed(),
                  controls: false,
                  pager: true,
                  touchEnabled: true,
                  adaptiveHeight: false
                });

                jQuery('#customPrevButton').on('click', function () {
                  self.sliderContainer.goToPrevSlide();
                });

                jQuery('#customNextButton').on('click', function () {
                  self.sliderContainer.goToNextSlide();
                });
              } else {
                self.sliderContainer && self.sliderContainer.redrawSlider();
              }
            }
          });
        });
      },

      install: function (settings, context_data) {
        this._install(settings, context_data);
        return jQuery.Deferred().resolve();
      },

      contextDataRequest: ['item'],

      validateContextDataRequest: function () {
        return true;
      },

      getContext: function () {
        var width = window.innerWidth;
        var sliderCollection;

        if (width >= 992) {
          sliderCollection = this.createSlideshowCollection('desktop');
        } else if (width >= 768) {
          sliderCollection = this.createSlideshowCollection('tablet');
        } else {
          sliderCollection = this.createSlideshowCollection('mobile');
        }
        var hasMoreThanOneSlide = sliderCollection.length > 1;
        var showArrows = this.settings.custrecord_show_arrows;
        var showOverlay = this.settings.custrecord_overlay_opacity;

        return {
          hasImages: sliderCollection.length > 0,
          slideshowList: sliderCollection,
          showCustomPager: null,
          sectionHeight: this.sectionHeight(),
          showSliderArrows: showArrows === 'T' && hasMoreThanOneSlide,
          overlay: showOverlay
        };
      },

      sliderAutoPlay: function () {
        return this.settings.custrecord_control_slideshow === 'T';
      },

      sliderSpeed: function () {
        return this.settings.custrecord_control_transition_duration || 5000;
      },

      createSlideshowCollection: function (typeScreen) {
        var slides = [];
        for (var i = 1; i <= 6; i++) {
          var slide = this.createSlide(i, typeScreen);
          if (slide.showSlide) {
            slides.push(slide);
          }
        }
        return slides;
      },

      createSlide: function (itemNumber, typeScreen) {
        var mediaData = this['mediaValidation' + this.capitalize(typeScreen)](itemNumber);
        return {
          showSlide: mediaData.showMedia,
          imageAlignment: 'uc-slider-image-alignment-' + this.getImageAlignmentByNumber(this.settings['custrecord_' + typeScreen + '_image_alignment_' + itemNumber]),
          imageURL: mediaData.imageURL,
          contentContainerPosition: 'uc-slider-container-alignment-' + this.getTextAlignment(this.settings['custrecord_' + typeScreen + '_text_alignment_' + itemNumber]),
          sliderWrapper: 'uc-slider-wrapper-' + this.getBackgroundWrapper(this.settings['custrecord_' + typeScreen + '_background_wrapper_' + itemNumber]),
          text: this.settings['custrecord_' + typeScreen + '_text_' + itemNumber],
          overlay: this.settings.custrecord_overlay_opacity === 'T'
        };

      },

      mediaValidationDesktop: function (itemNumber) {
        var url = this.settings['custrecord_desktop_image_' + itemNumber + '_url'] || '';
        return { showMedia: Boolean(url), imageURL: url };
      },

      mediaValidationTablet: function (itemNumber) {
        var url = this.settings['custrecord_tablet_image_' + itemNumber + '_url'] || '';
        return { showMedia: Boolean(url), imageURL: url };
      },

      mediaValidationMobile: function (itemNumber) {
        var url = this.settings['custrecord_mobile_image_' + itemNumber + '_url'] || '';
        return { showMedia: Boolean(url), imageURL: url };
      },

      sectionHeight: function () {
        return 'uc-slider-section-' + this.getSectionHeightByNumber(this.settings.custrecord_control_section_height);
      },

      getSectionHeightByNumber: function (num) {
        switch (parseInt(num)) {
        case 2: return 'medium';
        case 3: return 'large';
        default: return 'small';
        }
      },

      getImageAlignmentByNumber: function (num) {
        switch (parseInt(num)) {
        case 2: return 'center';
        case 3: return 'top';
        default: return 'bottom';
        }
      },

      getTextAlignment: function (num) {
        switch (parseInt(num)) {
        case 2: return 'left';
        case 3: return 'right';
        default: return 'center';
        }
      },

      getBackgroundWrapper: function (num) {
        switch (parseInt(num)) {
        case 1: return 'primary';
        case 2: return 'secondary';
        default: return 'none';
        }
      },

      capitalize: function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }

    });
  });
